import React, { useState, useEffect } from 'react';
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';
import Pricing from '../homecomponents/Precios.js';
import PageHeader from '../pagecomponents/PageHeader';

// Logos (ajusta rutas según tu proyecto)
import betherLogo from '../pagecomponents/logos/bether.png';
import bizneoLogo from '../pagecomponents/logos/bizneo.png';
import personioLogo from '../pagecomponents/logos/personio.png';
import kornferryLogo from '../pagecomponents/logos/kornferry.png';
import sesameLogo from '../pagecomponents/logos/sesame.png';
import workdayLogo from '../pagecomponents/logos/workday.png';
import factorialLogo from '../pagecomponents/logos/factorial.png';
import coachhubLogo from '../pagecomponents/logos/coach.png';
import freshpeopleLogo from '../pagecomponents/logos/fresh.png';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCapsules } from '@fortawesome/free-solid-svg-icons';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    padding: '40px 20px',
    backgroundColor: '#f9f9f9',
  },
  missionContainer: {
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  coreHeader: {
    textAlign: 'center',
    margin: '60px 0 40px',
  },
  coreRed: {
    color: '#ff2300',
  },
  missionText: {
    fontSize: '18px',
    color: '#333',
    lineHeight: '1.7',
    marginBottom: '20px',
    fontWeight: '500',
    whiteSpace: 'pre-wrap',
  },
  tableTitle: {
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: '600',
    margin: '40px 0 20px',
  },
  tableContainer: {
    overflowX: 'auto',
    padding: '20px',
    margin: '0 auto',
    maxWidth: '1200px',
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: '3px solid #ff2300',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  th: {
    backgroundColor: '#F8C4C1',
    padding: '12px',
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '16px',
  },
  td: {
    padding: '12px',
    textAlign: 'center',
  },
  logoCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px',
  },
  scoreColumn: {
    backgroundColor: '#F8C4C1',
    fontWeight: '700',
  },
  // Mobile card styles
  mobileCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  mobileCard: {
    backgroundColor: '#f9f9f9',
    border: '2px solid #ff2300',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  mobileRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  mobileLabel: {
    fontWeight: '600',
    flex: 1,
  },
  mobileScore: {
    backgroundColor: '#F8C4C1',
    fontWeight: '700',
    fontSize: '18px',
    padding: '6px 10px',
    borderRadius: '4px',
    marginLeft: '12px',
  },
  mobileLogo: {
    height: '56px', // la mitad de 16px
    width: 'auto',
  },
};

const dot = (color) => (
  <span
    style={{
      display: 'inline-block',
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: color,
    }}
  />
);

const columnLabels = [
  'Employee Plan Reporting',
  'Full Employee Assessment',
  'Objective Assessment',
  'AI-Personalized Growth Plans',
  'Daily Actionable Behaviors',
  'Evolution Tracking & Review',
  'Company Wide Data',
];

const rows = [
  {
    logo: betherLogo,
    name: 'Bether',
    cells: [
      '#6FCF97',
      '#6FCF97',
      '#6FCF97',
      '#6FCF97',
      '#6FCF97',
      '#6FCF97',
      '#6FCF97',
    ],
    score: '7/7',
  },
  {
    logo: bizneoLogo,
    name: 'Bizneo',
    cells: [
      '#6FCF97',
      '#6FCF97',
      '#EB5757',
      '#EB5757',
      '#EB5757',
      '#F2C94C',
      '#6FCF97',
    ],
    score: '3,5/7',
  },
  {
    logo: personioLogo,
    name: 'Personio',
    cells: [
      '#EB5757',
      '#6FCF97',
      '#EB5757',
      '#EB5757',
      '#EB5757',
      '#EB5757',
      '#F2C94C',
    ],
    score: '1,5/7',
  },
  {
    logo: kornferryLogo,
    name: 'Korn Ferry',
    cells: [
      '#EB5757',
      '#6FCF97',
      '#EB5757',
      '#EB5757',
      '#6FCF97',
      '#EB5757',
      '#EB5757',
    ],
    score: '2/7',
  },
  {
    logo: sesameLogo,
    name: 'Sesame',
    cells: [
      '#6FCF97',
      '#6FCF97',
      '#EB5757',
      '#EB5757',
      '#F2C94C',
      '#6FCF97',
      '#6FCF97',
    ],
    score: '4,5/7',
  },
  {
    logo: workdayLogo,
    name: 'Workday',
    cells: [
      '#6FCF97',
      '#EB5757',
      '#EB5757',
      '#EB5757',
      '#EB5757',
      '#6FCF97',
      '#6FCF97',
    ],
    score: '3/7',
  },
  {
    logo: factorialLogo,
    name: 'Factorial',
    cells: [
      '#6FCF97',
      '#F2C94C',
      '#EB5757',
      '#EB5757',
      '#EB5757',
      '#F2C94C',
      '#6FCF97',
    ],
    score: '3/7',
  },
  {
    logo: coachhubLogo,
    name: 'Coachhub',
    cells: [
      '#6FCF97',
      '#F2C94C',
      '#EB5757',
      '#EB5757',
      '#F2C94C',
      '#F2C94C',
      '#6FCF97',
    ],
    score: '3,5/7',
  },
  {
    logo: freshpeopleLogo,
    name: 'Freshpeople',
    cells: [
      '#6FCF97',
      '#F2C94C',
      '#F2C94C',
      '#F2C94C',
      '#EB5757',
      '#F2C94C',
      '#6FCF97',
    ],
    score: '4/7',
  },
];

export default function PricingPage() {
  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'es'
  );
  const [isMobile, setIsMobile] = useState(false);

  // Detectar móvil
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    handler(mq);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  // Guardar idioma
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const headerContent = {
    es: {
      title: 'Un valor enorme, por un precio módico',
      subtitle:
        'Consigue un ROI directo 5× en tiempo récord y un impacto económico total (TEI) de más de 10×. Despídete de implementaciones costosas y complicadas',
      ctaText: 'Ver Planes',
      claimTitle: ['Inversión a', ' futuro'],
      missionText:
        'Creemos que el desarrollo del talento no se resuelve con “pastillas milagrosas” de formación puntual que alivian lo inmediato, pero dejan intacta la raíz del problema. Apostamos por transformaciones reales y sostenibles, por eso nuestra plataforma está diseñada para sembrar mejoras que crecen con el tiempo y se mantienen vivas. Trabajamos con compromisos mínimos de 12 meses porque los grandes cambios necesitan espacio para germinar, consolidarse y dar frutos duraderos, convirtiendo cada aprendizaje en una ventaja competitiva de largo alcance.',
    },
    en: {
      title: 'Huge value, for a modest price',
      subtitle:
        'Achieve a direct ROI of 5× in record time and a total economic impact (TEI) exceeding 10×. Say goodbye to costly, complicated implementations.',
      ctaText: 'View Plans',
      claimTitle: ['Investment for', ' the future'],
      missionText:
        'We believe talent development isn’t solved with quick-fix “miracle pills” of one-off training that ease the pain now but leave the root problem untouched. We champion real, sustainable transformations, which is why our platform is built to plant improvements that grow over time and stay alive. We work with minimum commitments of 12 months because meaningful change needs space to germinate, take root, and bear lasting fruit—turning every learning into a long-term competitive edge.',
    },
  };

  const { title, subtitle, ctaText, claimTitle, missionText } =
    headerContent[language];

  const coreTitleStyle = {
    fontSize: isMobile ? '32px' : '60px',
    margin: 0,
    fontWeight: '700',
    lineHeight: '1.1',
  };

  const handleCtaClick = () => console.log('CTA Pricing clicked');

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />
      <PageHeader
        title={title}
        subtitle={subtitle}
        ctaText={ctaText}
        onCtaClick={handleCtaClick}
      />

      <main style={styles.main}>
        <div style={styles.missionContainer}>
          <hr
            style={{
              border: 'none',
              height: '2px',
              backgroundColor: '#ff2300',
              margin: '60px 0',
            }}
          />
          <div style={styles.coreHeader}>
            <FontAwesomeIcon
              icon={faCapsules}
              style={{
                color: '#ff2300',
                fontSize: isMobile ? '36px' : '56px',
                marginBottom: '16px',
              }}
            />
            <h2 style={coreTitleStyle}>
              <span style={{ color: '#222', marginRight: '8px' }}>
                {claimTitle[0]}
              </span>
              <span style={styles.coreRed}>{claimTitle[1]}</span>
            </h2>
          </div>
          <p style={styles.missionText}>{missionText}</p>
          <hr
            style={{
              border: 'none',
              height: '2px',
              backgroundColor: '#ff2300',
              margin: '60px 0 150px',
            }}
          />
        </div>

        <h3 style={styles.tableTitle}>
          {language === 'en' ? (
            <>
              Not another Employee Management Tool but{' '}
              <span style={styles.coreRed}>Talent Development Tool</span>
            </>
          ) : (
            <>
              No es otra herramienta de gestión de empleados, sino una{' '}
              <span style={styles.coreRed}>
                Herramienta de Desarrollo de Talento
              </span>
            </>
          )}
        </h3>

        <div style={styles.tableContainer}>
          {isMobile ? (
            <div style={styles.mobileCardContainer}>
              {rows.map((row, i) => (
                <div key={i} style={styles.mobileCard}>
                  <div style={{ ...styles.mobileRow, marginBottom: '12px' }}>
                    <img
                      src={row.logo}
                      alt={row.name}
                      style={styles.mobileLogo}
                    />
                    <div style={styles.mobileScore}>{row.score}</div>
                  </div>
                  {row.cells.map((color, idx) => (
                    <div key={idx} style={styles.mobileRow}>
                      <span style={styles.mobileLabel}>
                        {columnLabels[idx]}
                      </span>
                      {dot(color)}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}></th>
                  {columnLabels.map((label, idx) => (
                    <th key={idx} style={styles.th}>
                      {label}
                    </th>
                  ))}
                  <th style={{ ...styles.th, ...styles.scoreColumn }}>Score</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i}>
                    <td style={styles.logoCell}>
                      <img src={row.logo} alt={row.name} height="16" />
                    </td>
                    {row.cells.map((color, idx) => (
                      <td key={idx} style={styles.td}>
                        {dot(color)}
                      </td>
                    ))}
                    <td style={{ ...styles.td, ...styles.scoreColumn }}>
                      {row.score}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>

      <Pricing language={language} />
      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}
